import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const inputPlaceholderFn = /* @__PURE__ */ createRecipe('input-placeholder', {}, [])

const inputPlaceholderVariantMap = {}

const inputPlaceholderVariantKeys = Object.keys(inputPlaceholderVariantMap)

export const inputPlaceholder = /* @__PURE__ */ Object.assign(memo(inputPlaceholderFn.recipeFn), {
  __recipe__: true,
  __name__: 'inputPlaceholder',
  __getCompoundVariantCss__: inputPlaceholderFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: inputPlaceholderVariantKeys,
  variantMap: inputPlaceholderVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, inputPlaceholderVariantKeys)
  },
  getVariantProps: inputPlaceholderFn.getVariantProps,
})